import { isDate } from './isDate';

/**
 * @param {*} date - a Date object - could be unknown though
 * @returns {boolean} - whether it's a valid date
 */
export const isInvalidDate = (date: unknown): boolean => {
  if (!isDate(date)) {
    return true;
  }
  const time = date.getTime();

  return time === 0 || Number.isNaN(time);
};
